import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-tasks",
  "use": "app-icon-tasks-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"app-icon-tasks\"><g transform=\"translate(2 2)\" stroke-width=\"4\" fill=\"none\" fill-rule=\"evenodd\"><circle stroke=\"#FFF\" opacity=\".2\" cx=\"6\" cy=\"6\" r=\"6\" /><path d=\"M0 6a6 6 0 106-6\" stroke=\"#6B94EE\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol